import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Label, TabBar, TabItem } from '../components';
import cn from 'classnames';
import styles from './LandscapeStoryBaseEditTemplate.module.css';

interface LandscapeStoryBaseEditTemplateProps {
  children: React.ReactNode;
}

const LandscapeStoryBaseEditTemplate: React.FC<
  LandscapeStoryBaseEditTemplateProps
> = ({ children }) => {
  const navigate = useNavigate();
  const { id, storyId } = useParams();
  const location = useLocation();

  return (
    <div>
      <div className={cn(styles.heading)}>
        <Label content="Update Contact Story" size="lg" />
        <Button
          className={styles.buttonLink}
          onClick={() => navigate(`/landscapes/edit/${id}/updates`)}
          variant="link"
        >
          Go back to overview
        </Button>
      </div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={location.pathname}
      >
        <TabItem
          title="Story"
          id={`/landscapes/edit/${id}/updates/story/edit/${storyId}`}
        />
        <TabItem
          title="Content Blocks"
          id={`/landscapes/edit/${id}/updates/story/edit/${storyId}/content-blocks`}
        />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default LandscapeStoryBaseEditTemplate;
